import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = parentReducer => {
    return new class {
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.users;
        };
        selectReportTypes = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.reportTypes;
        };
        selectToDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.toDate;
        };
        selectFromDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.fromDate;
        };
        selectReports = createSelector(
            [
                this.selectUsers,
                this.selectReportTypes,
                this.selectFromDate,
                this.selectToDate
            ],
            (
                users = false,
                reportTypes = false,
                fromdate = false,
                todate = false
            ) => {
                if (users && reportTypes) {
                    let reportPerReportType = Object.keys(reportTypes).map(
                        e => {
                            let reportTotal = _.compact(
                                getReportTypePerUser(users, e)
                            );

                            if (fromdate) {
                                fromdate = moment(fromdate, "DD/MM/YYYY");
                                if (todate === false) {
                                    todate = fromdate;
                                } else todate = moment(todate, "DD/MM/YYYY");
                                reportTotal = filterByDate(
                                    reportTotal,
                                    fromdate,
                                    todate
                                );
                            }
                            if (reportTotal.length === 0) {
                                return {
                                    reportType: e,
                                    reportTotal: 0
                                };
                            } else {
                                let numReports = 0;
                                reportTotal.map(e => {
                                    numReports += Object.keys(e).length;
                                    return true;
                                });
                                return {
                                    reportType: e,
                                    reportTotal: numReports
                                };
                            }
                        }
                    );
                    let names = [],
                        reports = [];
                    Object.keys(reportPerReportType).map(e => {
                        names.push(
                            reportTypes[reportPerReportType[e].reportType]
                        );
                        reports.push(reportPerReportType[e].reportTotal);
                        return true;
                    });

                    let data = {
                        labels: names,
                        datasets: [
                            {
                                label: "Reports Total",
                                data: reports,
                                backgroundColor: "rgba(63,81,181,0.2)",
                                borderColor: "rgba(63,81,181,1)",
                                borderWidth: 1,
                                hoverBackgroundColor: "rgba(63,81,181,0.4)",
                                hoverBorderColor: "rgba(63,81,181,1)"
                            }
                        ]
                    };
                    return data;
                } else return false;
            }
        );
    }();
};

const getReportTypePerUser = (users, reportType) => {
    return Object.keys(users).map(e => {
        return _.get(users[e], `reports.${reportType}`) || null;
    });
};
const filterByDate = (orderedDailyReports, dateFrom, dateTo) => {
    return orderedDailyReports.map(e => {
        return _.filter(e, f => {
            let date = f.timestamp.split(" ")[0];
            let current = moment(date, "DD-MM-YYYY");
            return current.isBetween(dateFrom, dateTo, null, "[]");
        });
    });
};
export default createSelectors;
